module.exports = __webpack_public_path__ + "static/media/share-hover.876e6f83.svg";